import axios from "@/lib/axios";
import { serializeSortQueryParam } from "@/lib/utils";
import { SpringPage, SpringPageableRequest } from "@/types/apis";
import { Application, ApplicationStatus } from "@/types/applications";
import { EditionType } from "@/types/edition";

export type SearchApplicationsRequestParams = SpringPageableRequest & {
  companyId: string;
  status?: ApplicationStatus[];
  editionTypes?: EditionType[];
};

export type SearchApplicationsResponse = SpringPage<
  Application & {
    company: {
      id: string;
      name: string;
      segment: {
        companySize: string;
        sectorId: string;
        sector: string;
        subsectorId: string;
        subsector: string;
      };
    };
    edition: {
      id: string;
      name: string;
      year: number;
      type: EditionType;
    };
    forms: Array<{
      id: string;
      resourceId: string;
      formType: string;
      name: string;
    }>;
  }
>;

export const searchApplications = (params: SearchApplicationsRequestParams) =>
  axios
    .get<SearchApplicationsResponse>(
      `/v1/companies/${params.companyId}/applications`,
      {
        params: {
          page: params.page,
          size: params.size,
          status: params.status,
          editionTypes: params.editionTypes,
          sort: serializeSortQueryParam(params.sort),
        },
      },
    )
    .then((res) => res.data);
